import { Star } from 'lucide-react';
import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface StarRatingProps {
  readonly value: number;
  readonly size?: 'sm' | 'md';
}

/** 읽기 전용 별점. 소수는 반올림한 별 개수로 그리고 정확한 값은 접근성 이름으로 준다. */
export const StarRating = ({ value, size = 'md' }: StarRatingProps): ReactElement => {
  const filled = Math.round(value);
  return (
    <span
      role="img"
      aria-label={`별점 5점 중 ${value}점`}
      className="inline-flex items-center gap-0.5"
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          aria-hidden
          className={cn(
            size === 'sm' ? 'size-3.5' : 'size-4',
            n <= filled ? 'fill-foreground text-foreground' : 'text-muted-foreground/40',
          )}
        />
      ))}
    </span>
  );
};
